// extracted by mini-css-extract-plugin
module.exports = {"InfluencerSocial":"_1u77vw2i","section":"d6ClJ6iG"};